export default "__VITE_ASSET__CxMAEuK5__"